import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import './assets/main.scss';
import 'react-image-lightbox/style.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Utils from './components/Utils';
import Storage from './components/Storage';
import ApiCalls from './components/ApiCalls';
import { store, socket } from './store';

// Re-export para consumidores que aún importen desde './index'
export { store, socket };

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));
console.log(`Virtual Congress version: ${process.env.REACT_APP_VIRTUAL_CONGRESS_VERSION}`);
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter  >
        <Suspense fallback={<div className="loading" />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
serviceWorker.unregister();
